import axios from '@/utils/axios';

 export const allUsers = async () => {
  const response = await axios.get(`/users/all-users`);
  return response;
 };

 export const samplingUsers = async () => {
  const response = await axios.get(`/users/sampling`);
  return response;
 }

 export const approverUsers = async () => {
  const response = await axios.get(`/users/approver`);
  return response;
 } 

 export const productionUsers = async () => {
  const response = await axios.get(`/users/production`);
  return response;
 }  

 export const userById = async (id) => {
  try{
   const response = await axios.get(`/users/${id}`);
   return response.data.data;
  }catch(error){
   $swalToast("Not found", 'error');
   return null;
  }
 }
